import type { TranslationKey } from '@/hooks/useTranslation';
import { ClassificationOpportunityAndRisk } from '@/types/classification';

interface LegendProps {
  variant: 'opportunity' | 'risk';
  t: (key: TranslationKey) => string;
}

const mockedLegends = ({ variant, t }: LegendProps) => {
  const opportunityLegend = [
    {
      label: t('label.label.high'),
      color: '#06753C',
    },
    {
      label: t('label.label.medium_high'),
      color: '#00C056',
    },
    {
      label: t('label.label.medium_low'),
      color: '#70FFB5',
    },
    {
      label: t('label.label.low'),
      color: '#AEFFD5',
    },
  ];

  const riskLegend = [
    {
      label: t('label.label.high'),
      color: '#BE4E0E',
    },
    {
      label: t('label.label.medium_high'),
      color: '#E39338',
    },
    {
      label: t('label.label.medium_low'),
      color: '#FFB74D',
    },
    {
      label: t('label.label.low'),
      color: '#FFCC80',
    },
  ];
  return variant === 'opportunity' ? opportunityLegend : riskLegend;
};

interface LegendByClassificationProps {
  classification: ClassificationOpportunityAndRisk;
  t: (key: TranslationKey) => string;
}

const legendByClassification = ({ classification, t }: LegendByClassificationProps) => {
  switch (classification) {
    case ClassificationOpportunityAndRisk.HIGH:
      return t('label.label.high');
    case ClassificationOpportunityAndRisk.MEDIUM_HIGH:
      return t('label.label.medium_high');
    case ClassificationOpportunityAndRisk.MEDIUM_LOW:
      return t('label.label.medium_low');
    default:
      return t('label.label.low');
  }
};

export const legend = {
  mockedLegends,
  legendByClassification,
};
